import axios from "axios";

import { config } from "shared/data";

import type { MostPopularArticlesData } from "./types";

export const fetchMostPopularArticlesData = async () => {
  try {
    const resp = await axios.get<MostPopularArticlesData>(config.mostPopular.json);

    return resp?.data;
  } catch {
    return {
      global: [],
      hk: [],
    };
  }
};
